const PvzIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}>
    <path
      d="M15 17.5V8.33333C15 8.11232 14.9122 7.90036 14.7559 7.74408C14.5996 7.5878 14.3877 7.5 14.1667 7.5H5.83333C5.61232 7.5 5.40036 7.5878 5.24408 7.74408C5.0878 7.90036 5 8.11232 5 8.33333V17.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3332 15.835C18.3332 16.277 18.1576 16.7009 17.845 17.0135C17.5325 17.326 17.1085 17.5016 16.6665 17.5016H3.33317C2.89114 17.5016 2.46722 17.326 2.15466 17.0135C1.8421 16.7009 1.6665 16.277 1.6665 15.835V6.66829C1.66632 6.35443 1.75476 6.04691 1.92165 5.7811C2.08853 5.51529 2.32708 5.302 2.60984 5.16579L9.23484 1.85412C9.47143 1.7318 9.7339 1.66797 10.0003 1.66797C10.2666 1.66797 10.5291 1.7318 10.7657 1.85412L17.389 5.16579C17.6719 5.30188 17.9106 5.51512 18.0777 5.78094C18.2447 6.04675 18.3333 6.35435 18.3332 6.66829V15.835Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 10.832H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 14.168H15"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PvzIcon
